import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSettingsBranding } from '../hooks/useSettingsBranding';

export const AppBrand: React.FC = () => {
  const { t } = useTranslation();
  const { headerLogoUrl, displayName } = useSettingsBranding(false);

  const name = displayName || t('app.title');

  return (
    <div className="flex min-w-0 flex-1 items-center gap-2">
      {headerLogoUrl ? (
        <img
          src={headerLogoUrl}
          alt={name}
          className="max-h-10 w-auto max-w-[120px] shrink-0 object-contain object-left"
        />
      ) : null}
      <span className="truncate text-sm font-bold leading-tight text-primary sm:text-base">
        {name}
      </span>
    </div>
  );
};
